import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner, Row, Card, CardHeader, CardBody } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getTransferCompanyList } from '../../../slices/thunks';
import { Link } from 'react-router-dom';
import AddEditTransferCompanyModal from './Add_Edit/AddEditTransferCompanyModal';
import DeleteTransferCompany from './Delete/DeleteTransferCompany';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';

const TransferCompaniesList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorTransferCompanies = createSelector(
		state => state.TransferCompanies,
		transferCompany => ({
			transferCompanyList: transferCompany.transferCompanyList,
			isLoadingList: transferCompany.isLoadingList,
			isTransferCompanySuccess: transferCompany.isTransferCompanySuccess,
			error: transferCompany.error,
			isAdding: transferCompany.isAdding,
			isAdded: transferCompany.isAdded,
			isAddError: transferCompany.isAddError,
			isUpdating: transferCompany.isUpdating,
			isUpdated: transferCompany.isUpdated,
			isUpdateError: transferCompany.isUpdateError,
			isDeleting: transferCompany.isDeleting,
			isDeleted: transferCompany.isDeleted,
			isDeleteError: transferCompany.isDeleteError,
		})
	);

	const { transferCompanyList, isLoadingList } = useSelector(
		selectorTransferCompanies
	);

	useEffect(() => {
		dispatch(getTransferCompanyList());
	}, []);

	const [dataTransferCompany, setDataTransferCompany] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete TransferCompany
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = transferCompany => {
		setDataTransferCompany(transferCompany);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = transferCompany => {
		setDataTransferCompany(transferCompany);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'transferCompany',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const transferCompanyData =
														cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(transferCompanyData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const transferCompanyData =
														cellProps.row.original;
													handleClickDelete(transferCompanyData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{ header: 'RUT', accessorKey: 'rut', size: 'auto' },
			{ header: 'Nombre', accessorKey: 'name', size: 'auto' },

			{
				header: 'Tipo de Transporte',

				Cell: ({ row }) => {
					const transferTypes = row.original.transfer_type || []; // Si es null, se convierte en una lista vacía
					return (
						<div className='no-nowrap'>
							{transferTypes.map(item => item.name).join('; ')}
						</div>
					);
				},
				width: '15%',
			},
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataTransferCompany({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Empresa de Transporte
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={transferCompanyList || []}
								isLoadingData={isLoadingList}
								nameFile={'empresa_de_transporte'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataTransferCompany({});
											handleToggleModal();
										},
										title: 'Crear Empresa de Transporte',
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditTransferCompanyModal
				dataTransferCompany={dataTransferCompany}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteTransferCompany
				dataTransferCompany={dataTransferCompany}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default TransferCompaniesList;
